import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 自定义组件
import ElInputCurrency from "@components/ElInputCurrency"
import ElSelectEx from "@components/ElSelectEx"
import ElSelecRemotetEx from "@components/ElSelectRemoteEx"
import ElSelectTree from "@components/ElSelectTree"
import ElSelectTable from "@components/ElSelectTable"
import ElSelectTable2 from "@components/ElSelectTable2"
import ElTreeEx from "@components/ElTreeEx"
import ElFormDialog from "@components/ElFormDialog"
import ElTableDialog from "@components/ElTableDialog";
import '@components/ElButtonExport'

// 插件
import './plugins/element'
import './plugins/axios'
import './plugins/httpClient'
import './plugins/formDialog'

// 站点样式
import './assets/site.less'

// 指令
import './directives/index'

// 第三方
import Print from 'vue-print-nb'
Vue.use(Print)

Vue.component('el-input-currency', ElInputCurrency)
Vue.component('el-select-ex', ElSelectEx)
Vue.component('el-select-remote-ex', ElSelecRemotetEx)
Vue.component('el-select-tree', ElSelectTree)
Vue.component('el-select-table', ElSelectTable)
Vue.component('el-select-table2', ElSelectTable2)
Vue.component('el-tree-ex', ElTreeEx)
Vue.component('el-form-dialog', ElFormDialog)
Vue.component('el-table-dialog', ElTableDialog)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
